import { apiCall, APIValidationError } from '../api';
import { Result } from '../api.d';
import { addSearchParams } from '../../helpers/download';
import { baseURL } from '../root-saga';

export const getFileUploads = async (
  data: GetFileUploadsRequest,
): Promise<Result<GetFileUploadsResponse, APIValidationError>> => {
  const init = {
    method: 'GET',
    auth: true,
    role: true,
  };

  let url = new URL(`${baseURL}/api/file-uploads`);
  url = addSearchParams(url, {
    uploadable_id: data.uploadableId,
    uploadable_type: data.uploadableType,
  });

  return apiCall<GetFileUploadsResponse>(url.toString(), init);
};
